/**
 * Shared types for the 8 content renderers (UC-PORT-003).
 *
 * The backend returns `contentBlocks: unknown[]` because authoring tools may
 * evolve the per-renderer block shape independently. Each renderer narrows
 * the shape it expects with the helpers below; anything unexpected falls
 * back to a benign placeholder rather than throwing.
 */

export type RenderProps = {
  contentBlocks: unknown[];
};

export function asArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}

export function asString(value: unknown, fallback = ""): string {
  return typeof value === "string" ? value : fallback;
}

export function asObject(value: unknown): Record<string, unknown> {
  return typeof value === "object" && value !== null ? (value as Record<string, unknown>) : {};
}
